import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import {Warehouse, Warehouse1} from '../../project/warehouse';
import * as d3 from 'd3';


@Component({
  selector: 'app-rebar-detail',
  templateUrl: './rebar-detail.component.html'
})

export class RebarDetailComponent implements OnInit, OnChanges {

  margin = {top: 10, right: 15, bottom: 15, left: 15};
  width: number;
  height: number;
  svg: any;
  data: any;
  origin: any;
  end: any;
  div: string;
  circle_color = "#77768d";
  line_1_color = "#68a2ff";
  line_2_color = "#a4ccfd";
  radio = 20;
  stroke_width = 30;
  fontsize = "14px";

  @Input() selected: string;
  @Input() result: any;

  constructor() {
    this.div = "#rebar-detail";
  }

  ngOnInit() {
    this.width = 480 - this.margin.left - this.margin.right;
    this.height = 80 - this.margin.top - this.margin.bottom;
    this.prepareData();
    this.drawRebar();
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}){
    this.prepareData();
    if(this.svg && this.selected && this.result){
      this.removeText();
      this.addText();
    }
  }

  prepareData(){
    this.origin = [this.margin.right, this.height-this.margin.bottom];
    this.end = [this.width-this.margin.left, this.height-this.margin.bottom];

    this.data = {};
    this.data['1'] = (this.result && this.result["reinf"] && this.result["reinf"]["1"]) ? this.result["reinf"]["1"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['2'] = (this.result && this.result["reinf"] && this.result["reinf"]["2"]) ? this.result["reinf"]["2"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['3'] = (this.result && this.result["reinf"] && this.result["reinf"]["3"]) ? this.result["reinf"]["3"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['4'] = (this.result && this.result["reinf"] && this.result["reinf"]["4"]) ? this.result["reinf"]["4"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['5'] = (this.result && this.result["reinf"] && this.result["reinf"]["5"]) ? this.result["reinf"]["5"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['6'] = (this.result && this.result["reinf"] && this.result["reinf"]["6"]) ? this.result["reinf"]["6"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['7'] = (this.result && this.result["reinf"] && this.result["reinf"]["7"]) ? this.result["reinf"]["7"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.data['8'] = (this.result && this.result["reinf"] && this.result["reinf"]["8"]) ? this.result["reinf"]["8"]["envelope"]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  }

  drawRebar(){
    d3.select(this.div+" svg").remove();
    this.svg = d3.select(this.div)
      .append('svg')
      .style("position","relative")
      .style("left", "50%")
      .style("-webkit-transform", "translateX(-50%)")
      .style("-ms-transform", "translateX(-50%)")
      .style("transform", "translateX(-50%)")
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

      const step = (this.end[0]-this.origin[0])/13;
      for(let i = 0; i < 13; i++){
        let l1 = this.svg.append("line")
          .style("stroke", (i%2==0)? this.line_1_color: this.line_2_color)
          .style("stroke-width", this.stroke_width)
          .attr("class", "line")
          .attr("x1", this.origin[0]+step*i)
          .attr("y1", this.origin[1])
          .attr("x2", this.origin[0]+step*(i+1))
          .attr("y2", this.origin[1]);
      }

      let circle1 = this.svg.append("circle")
        .style("fill", this.circle_color)
        .attr("cx", this.origin[0]+this.radio/2)
        .attr("cy", this.origin[1])
        .attr("r", this.radio);

      let circle2 = this.svg.append("circle")
        .style("fill", this.circle_color)
        .attr("cx", this.end[0]-this.radio/2)
        .attr("cy", this.end[1])
        .attr("r", this.radio);

      for(let i = 0; i < 11; i++){
        let text = this.svg.append("text")
          .text(i+1)
          .attr("font-size", this.fontsize)
          .attr("font-weight", "bold")
          .attr("fill", this.circle_color)
          .attr("text-anchor", "middle")
          .attr("transform", "translate("+(this.origin[0]+step+(i*step)+step/2)+","+(this.origin[1]-this.stroke_width)+")");
      }
  }

  addText(){
    const step = (this.end[0]-this.origin[0])/13;
    for(let i = 0; i < 11; i++){
      let text = this.svg.append("text")
        .text(this.data[this.selected][i])
        .attr("font-size", this.fontsize)
        .attr("font-weight", "bold")
        .attr("fill", "white")
        .attr("text-anchor", "middle")
        .attr("class", "text")
        .attr("transform", "translate("+(this.origin[0]+step+(i*step)+step/2)+","+(this.origin[1]+5)+")");
    }
  }

  removeText(){
    this.svg.selectAll(".text").remove();
  }



}



// WEBPACK FOOTER //
// ./src/app/sketch/rebar-detail/rebar-detail.component.ts